import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';
import theme from '@dbk/ui-theme';
export default StyleSheet.create({
  flag: {
    width: 340,
    top: -10,
    left: -170,
   // borderWidth: 1,
   // borderColor: PALETTE.primaryActive,
    backgroundColor: "rgba(255, 255, 255, 0.1)",
    paddingTop: 3,
    paddingBottom: 20,
    paddingHorizontal: 6,
    height: 100,
    // boxShadow: "0.5px 0.5px 1px 0.5px #000",
    borderRadius: 2
  },
  flagDate: {
    color: PALETTE.secondaryActive,
    textAlign: 'center',
    marginTop: 13,
    fontSize: theme.fontSizeNativeSmall,
    //lineHeight: 26,
   // letterSpacing: 0.14
  },
  flagPrice: {
    color: PALETTE.secondaryActive,
    textAlign: 'center',
    marginTop: 8,
   // marginBottom: 20,
    fontSize: theme.fontSizeNativeSmall,
   // lineHeight: 24,
   // letterSpacing: 0.07
  },
});
